import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {ClaimDocumentsComponent} from "../../../claim-documents/claim-documents.component";
import {SideMenuService} from "../../../../services/side-menu.service";
import {ClaimService} from "../../../../services/claim.service";
import {DocumentHelperService} from "../../../../services/document-helper.service";
import {TransactionInfoService} from "../../../../services/transaction-info.service";
import {DocumentFormFactoryService} from "../../../../services/document-form-factory.service";
import {SpinnerService} from "../../../../core/spinner/spinner.service";
import {ClaimTypes} from "../../../../model/claim-type.model";
import {HttpClient} from "@angular/common/http";

declare var $: any;

@Component({
    selector: 'app-other-claim-upload-document',
    templateUrl: './other-claim-upload-document.component.html',
    styleUrls: ['./other-claim-upload-document.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class OtherClaimDMHUploadDocumentComponent extends ClaimDocumentsComponent implements OnInit {

    public upLoadFileModel: FormGroup;
    showTotalBox = false;
    
    constructor(private fb: FormBuilder,
        public sideMenuService: SideMenuService, 
        claimService: ClaimService,
        documentHelperService: DocumentHelperService,
        transactionInfoService: TransactionInfoService,
        http: HttpClient,
        documentFormFactoryService: DocumentFormFactoryService, spinnerService: SpinnerService, modalService: NgbModal) {
                super(claimService, documentHelperService, transactionInfoService, http, documentFormFactoryService, spinnerService, modalService);
                this.setCurrentClaimType(ClaimTypes[ClaimTypes.CLAIM_TYPE_DMH_OTHERS]); 
    }

    ngOnInit() {

        this.pushGAViewOtherClaimUpload();

        this.upLoadFileModel = this.fb.group(
            {
                airTicket: [],
                carrierCertificate: [],
                otherItems: this.fb.array([this.createItem()])

            });
            super.ngOnInit();
    }

    addFile() {
        let items = this.upLoadFileModel.get('otherItems') as FormArray;
        items.push(this.createItem());
    }

    createItem(): FormGroup {
        return this.fb.group({
            otherFile: [],
        });
    }

    showModal() {
        this.showTotalBox = true;
    }

    getData(msg) {
        this.showTotalBox = msg;
    }

    goToNext() {
        this.sideMenuService.emitProgress(1);
        this.sideMenuService.emitClaimComplete({claimTypeId: 9, subMenuIndex: 1});
    }

    //Google Analytics
    pushGAViewOtherClaimUpload() {
        (<any>window).dataLayer.push({
            'pageStep': 'Other Claims – Document Upload',
            'vPath': '/claim/other-claims/documents',
            'event': 'vpageview',
            'ecommerce': {
              'checkout': {
                  'actionField': {'step': 6},	//Step6-DocumentUpload
              }
            }                                                                                                                                                                              
        });
    }  

}
